import { render, staticRenderFns } from "./adv.vue?vue&type=template&id=71ccbd2e&scoped=true"
import script from "./adv.vue?vue&type=script&lang=js"
export * from "./adv.vue?vue&type=script&lang=js"
import style0 from "./adv.vue?vue&type=style&index=0&id=71ccbd2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ccbd2e",
  null
  
)

export default component.exports